<template>
  <div class="deck-widget">
    <b-skeleton-wrapper :loading="decks === null">
      <template #loading>
        <b-list-group flush>
          <b-list-group-item v-for="n in perPage" :key="$id(n)">
            <div class="d-flex w-100 align-items-center">
              <div class="user-deck-list-thumb mr-2 mr-md-3">
                <b-skeleton-img aspect="0.71"></b-skeleton-img>
              </div>
              <div class="d-flex flex-column align-items-start w-100">
                <div
                  class="d-flex w-100 justify-content-between align-items-baseline"
                >
                  <b-skeleton :width="`${getRndInteger(25, 75)}%`"></b-skeleton>
                  <b-skeleton
                    height="0.75em"
                    :width="`${getRndInteger(15, 20)}%`"
                  ></b-skeleton>
                </div>
                <b-skeleton
                  v-if="!hideUsername"
                  height="0.75em"
                  :width="`${getRndInteger(10, 25)}%`"
                ></b-skeleton>
              </div>
            </div>
          </b-list-group-item>
        </b-list-group>
      </template>
      <b-list-group flush>
        <b-list-group-item v-if="decks && !decks.length">
          <slot name="no-results">
            <em> There's nothing here. That seems odd... </em>
          </slot>
        </b-list-group-item>
        <b-list-group-item
          v-for="deck in decks"
          :key="deck.id"
          :to="{
            name: 'EditVersion',
            params: { familyId: deck.id, id: deck.version_id },
          }"
        >
          <div class="d-flex w-100 align-items-center">
            <b-img
              :blank="!deck.deck_data.appearance.cardbackUrl"
              :src="deck.deck_data.appearance.cardbackUrl"
              :blank-color="deck.deck_data.appearance.highlightColour"
              class="user-deck-list-thumb mr-2 mr-md-3"
            ></b-img>
            <div class="d-flex flex-column align-items-start w-100">
              <div
                class="d-flex w-100 justify-content-between align-items-baseline"
              >
                <div class="font-weight-bold">{{ deck.name }}</div>
                <small>{{ formattedDate(deck) }}</small>
              </div>
              <small v-if="!hideUsername">by {{ deck.user }}</small>
            </div>
          </div>
        </b-list-group-item>
      </b-list-group>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
import dateFormat from "@/mixins/dateFormat";

export default {
  name: "DecksWidget",
  mixins: [dateFormat],
  data() {
    return {};
  },
  props: {
    decks: {
      required: true,
      validator: (prop) => typeof Array.isArray(prop) || prop === null,
    },
    hideUsername: {
      type: Boolean,
      required: false,
      default: false,
    },
    dateField: {
      type: String,
      required: false,
      default: "deck_first_published_on",
    },
    defaultDateField: {
      type: String,
      required: false,
      default: "updated_on",
    },
    perPage: {
      type: Number,
      required: false,
      default: 3,
    },
  },
  methods: {
    formattedDate(deck) {
      return this.formatRelative(
        deck[this.dateField] || deck[this.defaultDateField]
      );
    },
    getRndInteger(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
  },
};
</script>

<style lang="less">
.deck-widget {
  flex: 1 1 auto;
  .user-deck-list-thumb {
    @card-height: 6ex;
    height: @card-height;
    width: 0.71 * @card-height;
    border-radius: 0.05 * @card-height;
    object-fit: cover;
    flex: 0 0 auto;
    align-self: center;
  }

  @media (max-width: 768px) {
    font-size: 14px;

    .list-group-item {
      padding: 0.25rem 0.75rem;
    }
    .user-deck-list-thumb {
      @card-height: 4ex;
      height: @card-height;
      width: 0.71 * @card-height;
      border-radius: 0.05 * @card-height;
    }
  }
}
</style>
